import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';

import Spinner from './Spinner';
import { getLocale, LocaleProvider } from './locales';
import { useBrandedDocTitle } from './utils';
import { BrandingDataProvider, Branding } from './dataProviders';
import useLayout from './useLayout';
import { makeBtStyles, Theme } from './Theme';

import FindOrderForm from './returns/FindOrderForm';
import ConfigureReturn from './returns/ConfigureReturn';
import ReturnConfirmation from './returns/ReturnConfirmation';


type ReturnsState = {
  order: any,
  setOrder: (newOrder:any) => void,
  label: any,
  setLabel: (newLabel:any) => void
};

const ReturnFlowContext = React.createContext({});

export const useReturnState = () => {
  return useContext(ReturnFlowContext) as ReturnsState;
};


const useStyles = makeBtStyles( (theme: Theme ) => ({
  card: {
    padding: '40px',
    margin: '50px auto',
    ...theme.card
  }
}));


export default function Returns() {
  const locale = getLocale();
  const [branding,setBranding] = useState<Branding>();
  const [returnState,setReturnState] = useState<any>({
    order: null,
    setOrder: (newOrder:any) => setReturnState( (oldState:any) => ({ ...oldState, order: newOrder }) ),
    label: null,
    setLabel: (newLabel:any) => setReturnState( (oldState:any) => ({ ...oldState, label: newLabel }) ),
  });

  useEffect( () => {
    if( !branding ) {
      axios.get('/branding').then(
        response => setBranding(response.data),
        error => { throw new Error(error); }
      );
    }
  }, [branding] );

  const Layout = useLayout(branding);

  useBrandedDocTitle(branding);

  if( !branding ) {
    return <Spinner />;
  }

  return <LocaleProvider locale={locale}>
    <BrandingDataProvider value={branding}>
      <ReturnFlowContext.Provider value={returnState}>
        <Layout.Layout>
          <ReturnsPage returnState={returnState} />
        </Layout.Layout>
      </ReturnFlowContext.Provider>
    </BrandingDataProvider>
  </LocaleProvider>;
}

const ReturnsPage = ({ returnState }:{ returnState:any }) => {
  const classes = useStyles();

  return !returnState.order ? (
    <FindOrderForm className={classes.card} />
  ):( (!returnState.label) ? (
    <ConfigureReturn className={classes.card} />
  ):(
    <ReturnConfirmation className={classes.card} />
  ))
}